export default {
  locale: "es",
  name: "Fechas de estancia excluidas",
  translation: { displayName: "Traducciones" },
  fields: {
    list: [
      {
        fieldName: "startDate",
        displayName: "Fecha inicio",
      },
      {
        fieldName: "endDate",
        displayName: "Fecha fin",
      },
    ],
    form: [
      {
        fieldName: "startDate",
        displayName: "Fecha inicio",
        widget: "datepicker",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Introducir fecha",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        selectsStart: true,
        className: "tickerInput closeButtonInside",
      },
      {
        fieldName: "endDate",
        displayName: "Fecha fin",
        widget: "datepicker",
        dateFormat: "YYYY-MM-DD",
        placeholder: "Introducir fecha",
        isRange: true,
        startField: "startDate",
        endField: "endDate",
        selectsEnd: true,
        className: "tickerInput closeButtonInside",
      },
    ],
  },
};
